module.exports = __webpack_public_path__ + "Icono_Complementos_512px.png";